import { AppThunk } from "../../store";

export enum NavigationKey {
    Tab = "Tab",
    ArrowRight = "ArrowRight",
    ArrowDown = "ArrowDown",
    ArrowLeft = "ArrowLeft",
    ArrowUp = "ArrowUp",
}

export enum ActionKey {
    Enter = "Enter"
}

export type TvKey = NavigationKey | ActionKey;

export type TvAction = () => AppThunk;

export interface ActionForElement {
    tab?: TvAction;
    left?: TvAction;
    up?: TvAction;
    right?: TvAction;
    down?: TvAction;
    enter?: TvAction;
}

export interface ConditionalItemMap<TFocusedElementKey> {
    focusedElementKey: TFocusedElementKey;
    elementActionsMap: Map<TFocusedElementKey, ActionForElement>;
}

export type ViewScreen<TState> = (state: TState) => ConditionalItemMap<unknown>;